import { Component, HostListener, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { Store } from "@ngrx/store";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { Observable, Subscription, filter } from "rxjs";
import { USER_FILES_DEFAULT_SORT_COLUMN, USER_FILES_DEFAULT_SORT_COLUMN_DIRECTION, USER_FILES_PAGE_DEFAULT_SIZE } from "src/app/conf/user-files";
import { UserFile } from "src/app/model/user-file";
import { AppState } from "src/app/store/app.reducer";
import { selectUserFileExported, selectUserFileUpdated } from "src/app/store/user-file/user-file.selector";
import * as UserFileActions from 'src/app/store//user-file/user-file.actions';
import { StandardNewValidator, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";

@Component({
	templateUrl: './board-users-files-dialog.component.html',
})

export class BoardUsersFilesDialogComponent implements OnInit, OnDestroy {
	// filesForm: FormGroup;

	addboarduserListForm: FormGroup;

	update$: Observable<boolean | undefined>;
	updateSub: Subscription;

	export$: Observable<boolean | undefined>;
	exportSub: Subscription;

	boarduserFile: UserFile = new UserFile();
	update: boolean;

	// design
	screenWidth: number;
	MIN_MD_WIDTH = 500;
	DELTA_ERROR_PIXEL = 7;
	MIN_TWO_BUTTONS_DIALOG_WIDTH = 575 + this.DELTA_ERROR_PIXEL;

	constructor(
		private store: Store<AppState>,
		private ref: DynamicDialogRef,
		public config: DynamicDialogConfig
	) {
		if (config.data!== undefined && config.data.boarduserFile!== undefined) {
			this.boarduserFile = config.data.boarduserFile;
			this.update = true;
		} else {
			this.boarduserFile = new UserFile();
			this.update = false;
		}
		this.initSelectors();
	}

	ngOnInit(): void {
		this.subscribeAll();
		this.buildForm();
		this.onResize();

		StandardNewValidator.setFirstCompile(true);
	}

	ngOnDestroy(): void {
		this.updateSub?.unsubscribe();
		this.exportSub?.unsubscribe();
	}

	initSelectors(): void {
		this.update$ = this.store.select(selectUserFileUpdated);
		this.export$ = this.store.select(selectUserFileExported);
	}

	buildForm(): void {
		this.addboarduserListForm = new FormGroup({
			'name': new FormControl(this.boarduserFile.Name, [Validators.required, Validators.minLength(5)]),
		});
	}

	subscribeAll(): void {
		this.updateSub = this.update$?.subscribe(
			(res) => {
				if (res){
					this.closeDialog();
				}
			}
		);
		this.exportSub = this.export$?.pipe(filter(res => !!res)).subscribe(
			(res) => {
				this.store.dispatch(UserFileActions.getBoarduserlists({ paging: {
					size: USER_FILES_PAGE_DEFAULT_SIZE,
					page: 1,
					sort: USER_FILES_DEFAULT_SORT_COLUMN,
					order: USER_FILES_DEFAULT_SORT_COLUMN_DIRECTION,
				}}));
				this.closeDialog();
			}
		);
	}

	get f(): any {
		return this.addboarduserListForm.controls;
	}

	getFormValidationErrors(): boolean {
		let atLeastOneError = false;
		Object.keys(this.addboarduserListForm.controls).forEach(key => {
			const controlErrors: ValidationErrors = this.addboarduserListForm.get(key).errors;
			if (controlErrors != null) {
				/* Object.keys(controlErrors).forEach(keyError => {
					console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
				}); */
				atLeastOneError = true;
			}
		});
		return atLeastOneError;
	}

	submit(): void {
		StandardNewValidator.setFirstCompile(false);
		if (!this.getFormValidationErrors()) {
			this.save();
		}
	}

	save(): void { 
		if (this.update) {
			 this.store.dispatch(UserFileActions.updateBoarduserList({
				  boarduserList: {
						...this.boarduserFile,
						Name: this.addboarduserListForm.value.name
				  }
			 }));
		} else {
			 this.store.dispatch(UserFileActions.exportBoarduserList({ 
				name: this.addboarduserListForm.value.name 
			}));
		}
	}

	closeDialog(): void {
		this.ref.close();
	}

	@HostListener('window:resize', ['$event'])
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	dynamicButtonWidth() : string {
		return StandardPageLayout.dynamicButtonWidth(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth,'w-30rem');
	}

	justifyContentStyle(): string {
		return StandardNewValidator.justifyMessagesNewValidator(this.screenWidth);
	}

	newShowErrors(type: BoardUsersFilesDialogComponent['f'], classType: string): string {
		return StandardNewValidator.newShowErrors(type,classType,this.screenWidth);
	}

	showErrorRequiredMessage(type: BoardUsersFilesDialogComponent['f']): boolean {
		return StandardNewValidator.showErrorRequiredMessage(type);
	}
}